var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notFound"}},[_c('h1',[_vm._v("非法访问,请向管理员申请权限!")])])
}]

export { render, staticRenderFns }